import type { LdLead, LdSourceDef, LdSourceKey, LdStatusDef, LdStatusKey } from './types';

export const LD_STATUS: Record<LdStatusKey, LdStatusDef> = {
  new: { label: 'New lead', tone: 'info' },
  contacted: { label: 'Contacted', tone: 'gold' },
  booked: { label: 'Booked', tone: 'ai' },
  showed: { label: 'Showed up', tone: 'success' },
  treated: { label: 'Treated', tone: 'success' },
  noshow: { label: 'No-show', tone: 'terra' },
  lost: { label: 'Lost', tone: 'neutral' },
};

export const LD_SOURCE: Record<LdSourceKey, LdSourceDef> = {
  call: { label: 'Phone call', icon: 'phone', tone: 'success' },
  form: { label: 'Online form', icon: 'doc', tone: 'info' },
};

export const LD_LEADS: LdLead[] = [
  {
    id: 1,
    name: 'Maria Santos',
    phone: '(905) 555-0187',
    source: 'call',
    campaign: 'Emergency Dental',
    keyword: 'emergency dentist near me',
    date: 'Apr 9, 2:14 PM',
    duration: '3:42',
    status: 'treated',
    treatment: 'Emergency extraction + temp crown',
    value: 680,
    apptDate: 'Apr 9, 4:30 PM',
  },
  {
    id: 2,
    name: 'David Thompson',
    phone: '(905) 555-0234',
    source: 'form',
    campaign: 'Dental Implants',
    keyword: 'dental implants cost',
    date: 'Apr 9, 11:20 AM',
    duration: null,
    status: 'booked',
    treatment: 'Implant consultation',
    value: null,
    apptDate: 'Apr 14, 10:00 AM',
  },
  {
    id: 3,
    name: 'Sarah Kim',
    phone: '(905) 555-0312',
    source: 'call',
    campaign: 'Teeth Whitening',
    keyword: 'teeth whitening near me',
    date: 'Apr 8, 6:45 PM',
    duration: '2:18',
    status: 'treated',
    treatment: 'In-office whitening',
    value: 350,
    apptDate: 'Apr 9, 11:00 AM',
  },
  {
    id: 4,
    name: 'James Wilson',
    phone: '(905) 555-0456',
    source: 'call',
    campaign: 'Emergency Dental',
    keyword: 'broken tooth repair',
    date: 'Apr 8, 3:22 PM',
    duration: '1:54',
    status: 'treated',
    treatment: 'Crown repair + filling',
    value: 420,
    apptDate: 'Apr 8, 5:00 PM',
  },
  {
    id: 5,
    name: 'Rosa Hernandez',
    phone: '(905) 555-0198',
    source: 'form',
    campaign: 'Dentista de Emergencia',
    keyword: 'dentista cerca de mi',
    date: 'Apr 8, 10:05 AM',
    duration: null,
    status: 'showed',
    treatment: 'Exam + cleaning',
    value: 280,
    apptDate: 'Apr 9, 9:00 AM',
  },
  {
    id: 6,
    name: 'Michael Chen',
    phone: '(905) 555-0567',
    source: 'call',
    campaign: 'Invisalign',
    keyword: 'invisalign cost',
    date: 'Apr 7, 4:30 PM',
    duration: '5:12',
    status: 'booked',
    treatment: 'Invisalign consultation',
    value: null,
    apptDate: 'Apr 15, 2:00 PM',
  },
  {
    id: 7,
    name: 'Jennifer Lee',
    phone: '(905) 555-0678',
    source: 'form',
    campaign: 'Family Dentist',
    keyword: 'kids dentist near me',
    date: 'Apr 7, 2:15 PM',
    duration: null,
    status: 'treated',
    treatment: '2 kids checkups + cleaning',
    value: 440,
    apptDate: 'Apr 8, 3:30 PM',
  },
  {
    id: 8,
    name: 'Robert Patel',
    phone: '(905) 555-0789',
    source: 'call',
    campaign: 'Dental Implants',
    keyword: 'all-on-4 dentist',
    date: 'Apr 7, 11:40 AM',
    duration: '4:28',
    status: 'booked',
    treatment: 'All-on-4 consultation',
    value: null,
    apptDate: 'Apr 16, 9:00 AM',
  },
  {
    id: 9,
    name: 'Amanda Brown',
    phone: '(905) 555-0890',
    source: 'call',
    campaign: 'Emergency Dental',
    keyword: 'dental pain relief',
    date: 'Apr 6, 8:15 PM',
    duration: '2:05',
    status: 'noshow',
    treatment: null,
    value: 0,
    apptDate: 'Apr 7, 9:00 AM',
  },
  {
    id: 10,
    name: 'Carlos Rivera',
    phone: '(905) 555-0901',
    source: 'form',
    campaign: 'Teeth Whitening',
    keyword: 'professional whitening cost',
    date: 'Apr 6, 5:30 PM',
    duration: null,
    status: 'contacted',
    treatment: null,
    value: null,
    apptDate: null,
  },
  {
    id: 11,
    name: 'Lisa Park',
    phone: '(905) 555-0112',
    source: 'call',
    campaign: 'Cosmetic Veneers',
    keyword: 'veneers near me',
    date: 'Apr 6, 1:20 PM',
    duration: '3:55',
    status: 'booked',
    treatment: 'Veneer consultation',
    value: null,
    apptDate: 'Apr 17, 11:00 AM',
  },
  {
    id: 12,
    name: 'Unknown Caller',
    phone: '(905) 555-0223',
    source: 'call',
    campaign: 'Emergency Dental',
    keyword: 'emergency tooth extraction',
    date: 'Apr 5, 9:45 PM',
    duration: '0:32',
    status: 'lost',
    treatment: null,
    value: 0,
    apptDate: null,
  },
  {
    id: 13,
    name: 'Priya Sharma',
    phone: '(905) 555-0334',
    source: 'form',
    campaign: 'Weekend Emergency',
    keyword: 'weekend dentist',
    date: 'Apr 5, 7:10 PM',
    duration: null,
    status: 'treated',
    treatment: 'Emergency root canal',
    value: 890,
    apptDate: 'Apr 6, 10:00 AM',
  },
  {
    id: 14,
    name: 'Tom Mitchell',
    phone: '(905) 555-0445',
    source: 'call',
    campaign: 'Family Dentist',
    keyword: 'family dentist brampton',
    date: 'Apr 5, 3:00 PM',
    duration: '2:48',
    status: 'treated',
    treatment: 'Family checkup (3 patients)',
    value: 660,
    apptDate: 'Apr 7, 2:00 PM',
  },
  {
    id: 15,
    name: 'Ana Gutierrez',
    phone: '(905) 555-0556',
    source: 'form',
    campaign: 'Dentista de Emergencia',
    keyword: 'dentista de emergencia',
    date: 'Apr 4, 11:30 AM',
    duration: null,
    status: 'new',
    treatment: null,
    value: null,
    apptDate: null,
  },
];

export const LD_CAMPAIGNS = [
  'All campaigns',
  'Emergency Dental',
  'Dental Implants',
  'Teeth Whitening',
  'Invisalign',
  'Family Dentist',
  'Dentista de Emergencia',
  'Cosmetic Veneers',
  'Weekend Emergency',
];

export const LD_STATUS_FILTERS: readonly (LdStatusKey | 'All')[] = [
  'All',
  'new',
  'contacted',
  'booked',
  'showed',
  'treated',
  'noshow',
  'lost',
];
